<div class="mb-6 text-base font-bold text-black">Training Details</div>
<div class="mb-6 flex justify-end">
	<button routerLink="/{{ routeType.REPORT }}" class="aa-btn" data-variant="tertiary" data-size="small">Back</button>
</div>
<div class="rounded-md bg-blue-10 p-2 lg:p-6">
	@if (isNotPilot) {
		<div class="flex w-full flex-col gap-4 sm:flex-row sm:items-end">
			<div class="form-element w-full sm:w-1/2">
				<mat-label>Candidate Name</mat-label>
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field-responsive mt-1 w-full">
					<input #searchCandidateName type="text" id="searchCandidateName" name="searchCandidateName" matInput />
				</mat-form-field>
			</div>
			<div class="form-element w-full sm:w-1/2">
				<mat-label>Staff Number</mat-label>
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field-responsive mt-1 w-full">
					<input #searchStaffNumber type="text" id="searchStaffNumber" name="searchStaffNumber" matInput />
				</mat-form-field>
			</div>
			<div class="flex shrink-0 gap-2">
				<button
					aria-label="Search"
					(click)="handleSearch(searchCandidateName, searchStaffNumber)"
					class="aa-btn"
					data-variant="tertiary"
				>
					Search
				</button>
				<button
					aria-label="Clear"
					(click)="clearSearch(searchCandidateName, searchStaffNumber)"
					class="aa-btn"
					data-variant="tertiary"
				>
					Reset
				</button>
			</div>
		</div>
	}

	<div class="mb-4 text-base font-bold text-black">Sessions</div>
	<mat-accordion [multi]="true" id="session-accordion-container">
		@for (
			session of trainingDetails?.sessions;
			track session.assessmentDate + "|" + sessionTitle(session);
			let i = $index
		) {
			@if (session.candidates) {
				<mat-expansion-panel class="session-accordion" [expanded]="session.candidates.length > 0">
					<mat-expansion-panel-header #panelH class="session-accordion-header">
						<mat-panel-title (click)="panelH._toggle()">
							<div class="session-details">
								<h3>{{ sessionTitle(session) }}</h3>
								<span>{{ session.assessmentDate }}</span>
							</div>
						</mat-panel-title>
						<mat-panel-description (click)="panelH._toggle()" class="flex justify-end">
							@if (rs.isAdmin || rs.isOfficeAdmin) {
								<button
									(click)="downloadAll(i)"
									[disabled]="this.selected[i] && this.selected[i].length === 0"
									class="aa-btn download-btn"
									data-size="small"
								>
									Download
								</button>
							}
						</mat-panel-description>
					</mat-expansion-panel-header>
					<app-cbta-students-table
						(onDownload)="download($event)"
						(onSelect)="setSelected(i, $event)"
						[students]="session.candidates"
					></app-cbta-students-table>
				</mat-expansion-panel>
			}
		}
		@if (hasNoSessions) {
			<div>
				<div class="no-session-found">No sessions found.</div>
			</div>
		}
	</mat-accordion>
</div>
